import React from 'react';
import Icon from '../../../components/AppIcon';

const BodyRegionSelector = ({ 
  selectedRegion, 
  onRegionChange 
}) => {
  const bodyRegions = [
    { id: 'head', label: 'Head & Neck', icon: 'Brain', description: 'Cranial, facial, cervical imaging' },
    { id: 'chest', label: 'Chest', icon: 'Heart', description: 'Thoracic, cardiac, pulmonary' },
    { id: 'abdomen', label: 'Abdomen', icon: 'Activity', description: 'Abdominal organs, GI tract' },
    { id: 'pelvis', label: 'Pelvis', icon: 'Circle', description: 'Pelvic organs, reproductive' },
    { id: 'spine', label: 'Spine', icon: 'Columns', description: 'Cervical, thoracic, lumbar' },
    { id: 'musculoskeletal', label: 'Musculoskeletal', icon: 'Bone', description: 'Extremities, joints, bones' },
    { id: 'vascular', label: 'Vascular', icon: 'GitBranch', description: 'Arterial, venous imaging' },
    { id: 'breast', label: 'Breast', icon: 'Circle', description: 'Mammography, breast imaging' },
    { id: 'fullbody', label: 'Full Body', icon: 'User', description: 'Complete body scan, systemic assessment' }
  ];

  return (
    <div className="clinical-card p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Target" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-foreground">Body Region Selection</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-4">
        Select the anatomical region requiring imaging assessment
      </p>
      
      {/* Desktop/Tablet: Grid View */}
      <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-4 gap-3">
        {bodyRegions?.map((region) => (
          <button
            key={region?.id}
            onClick={() => onRegionChange(region?.id)}
            className={`
              flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-clinical
              ${selectedRegion === region?.id
                ? 'border-primary bg-primary/10' :'border-border bg-background hover:border-primary/50 hover:bg-muted/50'
              }
            `}
          >
            <Icon 
              name={region?.icon} 
              size={24} 
              color={selectedRegion === region?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
            />
            <span className={`
              text-xs font-medium text-center
              ${selectedRegion === region?.id ? 'text-primary' : 'text-foreground'}
            `}>
              {region?.label}
            </span>
          </button>
        ))}
      </div>

      {/* Mobile: List View */}
      <div className="md:hidden space-y-2">
        {bodyRegions?.map((region) => (
          <button
            key={region?.id}
            onClick={() => onRegionChange(region?.id)}
            className={`
              w-full flex items-center gap-3 p-3 rounded-lg border-2 transition-clinical
              ${selectedRegion === region?.id
                ? 'border-primary bg-primary/10' :'border-border bg-background hover:border-primary/50 hover:bg-muted/50'
              }
            `}
          >
            <Icon 
              name={region?.icon} 
              size={20} 
              color={selectedRegion === region?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
            />
            <span className={`
              text-sm font-medium
              ${selectedRegion === region?.id ? 'text-primary' : 'text-foreground'}
            `}>
              {region?.label}
            </span>
            {selectedRegion === region?.id && (
              <Icon name="Check" size={16} color="var(--color-primary)" className="ml-auto" />
            )}
          </button>
        ))}
      </div>

      {selectedRegion && (
        <div className="mt-4 p-3 bg-primary/10 rounded-lg">
          <p className="text-sm text-primary font-medium">
            Selected: {bodyRegions?.find(r => r?.id === selectedRegion)?.label}
          </p>
        </div>
      )}
    </div>
  );
};

export default BodyRegionSelector;